module.exports = __webpack_public_path__ + "static/media/ps_5.3667b3a0.svg";